// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-list {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-primary);
  position: relative;
}

.message-list-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  scrollbar-width: thin;
  scroll-behavior: smooth;
}

/* Custom Scrollbar for Chat Area */
.message-list-scroll::-webkit-scrollbar {
  width: 8px;
}

.message-list-scroll::-webkit-scrollbar-track {
  background: var(--bg-primary);
}

.message-list-scroll::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.15));
  border-radius: 4px;
}

.message-list-scroll:hover::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.3));
  filter: brightness(1.2);
}

.message-list-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.new-messages-button {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--gradient-brand);
  color: white;
  padding: 10px 24px;
  border-radius: 20px;
  border: none;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(153, 27, 27, 0.4);
  z-index: 100;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(8px);
}

.new-messages-button:hover {
  transform: translateX(-50%) translateY(-4px);
  box-shadow: 0 12px 32px rgba(153, 27, 27, 0.6);
  filter: brightness(1.1);
}

.new-messages-button:active {
  transform: translateX(-50%) translateY(0);
}

/* Premium Welcome State */
.channel-start {
  padding: 80px 24px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 640px;
  margin: 0 auto 60px;
}

.channel-start-icon-box {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.channel-start-icon-inner {
  width: 84px;
  height: 84px;
  background: var(--gradient-brand);
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  z-index: 2;
  box-shadow: var(--shadow-xl);
  transform: rotate(-4deg);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.channel-start-icon-glow {
  position: absolute;
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(153, 27, 27, 0.4) 0%, transparent 70%);
  filter: blur(20px);
  z-index: 1;
  animation: pulse-glow 3s infinite alternate;
}

.channel-start-title {
  font-size: 32px;
  font-weight: 900;
  color: var(--text-primary);
  margin-bottom: 16px;
  letter-spacing: -0.03em;
}

.channel-start-description {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 480px;
  margin-bottom: 32px;
}

.channel-start-actions {
  display: flex;
  gap: 12px;
}

.channel-action-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 38px;
  padding: 0 18px;
  background-color: var(--bg-modifier-hover);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-normal);
  white-space: nowrap;
}

.channel-action-chip:hover {
  background-color: var(--bg-modifier-active);
  border-color: var(--brand-primary);
  color: var(--text-primary);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(153, 27, 27, 0.2);
}

.channel-start-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--glass-border), transparent);
  margin-top: 48px;
}

/* Message Items (Discord flat row layout) */
.message-item {
  display: flex;
  gap: 16px;
  padding: 4px 16px;
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
  position: relative;
  width: 100%;
  max-width: 100%;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.message-item:hover {
  background-color: rgba(255, 255, 255, 0.02) !important;
  border: none !important;
  box-shadow: none !important;
}

/* DM Mode - Self messages right-aligned */
.message-item-dm {
  max-width: 100%;
}

.message-item-self {
  flex-direction: row-reverse;
  align-self: flex-end;
  max-width: 80%;
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
  padding: 4px 20px;
}

.message-item-self:hover {
  background: transparent !important;
  box-shadow: none !important;
}

.message-item-self .message-container {
  align-items: flex-end;
}

.message-item-self.highlight-animation {
  animation: highlight-reply-self 2s ease-in-out !important;
}

@keyframes highlight-reply-self {
  0%, 100% {
    background-color: transparent !important;
    box-shadow: none !important;
  }
  20% {
    background-color: rgba(185, 28, 28, 0.4) !important;
    box-shadow: 0 0 15px rgba(185, 28, 28, 0.4) !important;
  }
  80% {
    background-color: rgba(185, 28, 28, 0.2) !important;
    box-shadow: 0 0 5px rgba(185, 28, 28, 0.2) !important;
  }
}

/* DM Self message reply context */
.message-item-self .message-reply-context {
  flex-direction: row-reverse;
  border-radius: var(--radius-lg) 0 0 var(--radius-lg);
  border-left: 1px solid rgba(153, 27, 27, 0.2);
  border-right: none;
  background: linear-gradient(315deg, rgba(153, 27, 27, 0.08), rgba(153, 27, 27, 0.04));
  margin-left: auto;
}

.message-item-self .message-reply-accent {
  margin-right: 0;
  margin-left: 10px;
}

.message-item-self .message-reply-body {
  text-align: right;
}

.message-item-self .message-reply-author {
  /* Swap arrow direction visually by moving icon to right or using a different one, but let's just align text */
  text-align: right;
}

/* DM Bubble Styles - Flat Discord Style (no dark bubbles or shadows) */
.message-bubble-self,
.message-bubble-other {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  max-width: 100% !important;
  word-break: break-word;
  line-height: 1.5;
}

.message-bubble-self a,
.message-bubble-self .message-link-highlight,
.message-bubble-other a,
.message-bubble-other .message-link-highlight {
  color: #00a8fc !important;
  text-decoration: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.message-bubble-self a:hover,
.message-bubble-self .message-link-highlight:hover,
.message-bubble-other a:hover,
.message-bubble-other .message-link-highlight:hover {
  text-decoration: underline !important;
}

/* Read receipt / message status */
.message-status {
  display: flex;
  justify-content: flex-end;
  margin-top: 3px;
  padding-right: 2px;
}

.message-status-icon {
  color: var(--brand-light);
  opacity: 0.7;
}

.message-status-icon.read {
  color: #60a5fa;
  opacity: 1;
}


.message-avatar {
  flex-shrink: 0;
  margin-top: 4px;
  width: 44px;
  height: 44px;
}

.avatar-img {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  object-fit: cover;
  border: 1.5px solid var(--glass-border);
  box-shadow: var(--shadow-sm);
  display: block;
}

.avatar-inner {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background-color: var(--bg-tertiary);
  border: 1.5px solid var(--glass-border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: var(--brand-light);
  font-size: 18px;
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-normal);
}

.message-item:hover .avatar-inner {
  transform: scale(1.05) rotate(2deg);
  border-color: var(--brand-primary);
}

.message-container {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.message-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.message-author {
  font-size: 15px;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  gap: 6px;
}

.bot-tag {
  background: var(--brand-primary);
  color: white;
  font-size: 9px;
  font-weight: 900;
  padding: 1px 4px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  height: 14px;
}

.message-timestamp {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  opacity: 0.5;
}

.message-edited {
  font-size: 11px;
  color: var(--text-muted);
  opacity: 0.4;
  font-style: normal;
}

.message-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-text {
  font-size: 15px;
  line-height: 1.6;
  color: #f8fafc;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-weight: 500;
}

.message-link-highlight {
  color: #00a8fc !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  padding: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  border-bottom: none !important;
  word-break: break-all;
  overflow-wrap: anywhere;
  cursor: pointer;
  transition: color 0.15s ease;
}

.message-link-highlight:hover {
  color: #00a8fc !important;
  text-decoration: underline !important;
  background: transparent !important;
  border-bottom: none !important;
}

/* Discord-Style Rich Link Embeds */
.discord-link-embed {
  margin-top: 6px;
  max-width: 520px;
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 4px;
  padding: 12px 16px;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.discord-link-embed.direct-media-embed {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  max-width: 520px;
}

.direct-embed-video {
  max-width: 100%;
  max-height: 380px;
  border-radius: 8px;
  background: #000;
  display: block;
}

.direct-embed-image {
  max-width: 100%;
  max-height: 380px;
  border-radius: 8px;
  object-fit: contain;
  cursor: pointer;
  display: block;
}

.embed-provider-row {
  font-size: 11px;
  font-weight: 700;
  color: #949ba4;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.embed-author-row {
  font-size: 13px;
  font-weight: 700;
  color: #f2f3f5;
}

.embed-author-link,
.embed-author-text {
  color: #f2f3f5;
  text-decoration: none;
}
.embed-author-link:hover {
  text-decoration: underline;
}

.embed-title-row {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
}

.embed-title-link {
  color: #00a8fc !important;
  text-decoration: none;
}
.embed-title-link:hover {
  text-decoration: underline;
}

.embed-description-text {
  font-size: 13px;
  color: #dbdee1;
  line-height: 1.4;
  margin-top: 2px;
}

.embed-video-container {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 6px;
  background: #000;
}

.youtube-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* SoundCloud Embed Box */
.soundcloud-media-container {
  margin-top: 8px;
  width: 100%;
}

.soundcloud-artwork-box {
  position: relative;
  width: 100%;
  max-width: 480px;
  height: 280px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #111214;
}

.soundcloud-artwork-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.soundcloud-artwork-box:hover .soundcloud-artwork-img {
  transform: scale(1.02);
}

.soundcloud-play-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  transition: background-color 0.2s ease;
}

.soundcloud-artwork-box:hover .soundcloud-play-overlay {
  background: rgba(0, 0, 0, 0.45);
}

.soundcloud-play-button {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #ff5500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(255, 85, 0, 0.5);
  transition: transform 0.15s ease;
}

.soundcloud-artwork-box:hover .soundcloud-play-button {
  transform: scale(1.1);
}

.embed-thumbnail-container {
  margin-top: 8px;
  max-width: 100%;
  max-height: 280px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.embed-thumbnail-img {
  max-width: 100%;
  max-height: 280px;
  object-fit: cover;
  border-radius: 8px;
}

.message-reply-context {
  display: flex;
  align-items: stretch;
  background: linear-gradient(135deg, rgba(153, 27, 27, 0.08), rgba(153, 27, 27, 0.04));
  border: 1px solid rgba(153, 27, 27, 0.2);
  border-left: none;
  padding: 8px 12px;
  border-radius: 0 var(--radius-lg) var(--radius-lg) 0;
  margin-bottom: 8px;
  cursor: pointer;
  max-width: 520px;
  transition: all var(--transition-fast);
  overflow: hidden;
}

.message-reply-accent {
  width: 3px;
  min-width: 3px;
  background: var(--brand-primary);
  border-radius: 3px;
  margin-right: 10px;
  flex-shrink: 0;
}

.message-reply-context:hover {
  background: linear-gradient(135deg, rgba(153, 27, 27, 0.14), rgba(153, 27, 27, 0.08));
  border-color: rgba(153, 27, 27, 0.4);
}

.message-reply-author {
  display: block;
  font-size: 12px;
  font-weight: 800;
  color: var(--brand-light);
  margin-bottom: 4px;
}

.message-reply-preview {
  font-size: 13px;
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  overflow: hidden;
}

.attachment-item {
  max-width: 100% !important;
  display: block;
}

.attachment-image-wrapper {
  width: 100%;
  max-width: 400px !important;
  max-height: 300px !important;
  aspect-ratio: auto;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--glass-border);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.attachment-image-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);
  border-color: var(--brand-primary);
}

.attachment-image-wrapper img {
  display: block;
  max-width: 400px !important;
  max-height: 300px !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain;
  border-radius: 8px;
}

.attachment-file-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 12px 20px;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  transition: 0.2s;
  min-width: 280px;
}

.attachment-file-box:hover {
  background: rgba(30, 41, 59, 0.8);
  border-color: var(--brand-primary);
}

.file-icon-box {
  font-size: 24px;
}

.file-name {
  font-weight: 700;
  font-size: 14px;
  color: #f8fafc;
  margin-bottom: 2px;
}

.file-meta {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
}


.message-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.reaction-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-width: 44px;
  justify-content: center;
}

.reaction-pill:hover {
  border-color: var(--brand-primary);
  background-color: rgba(153, 27, 27, 0.05);
  transform: scale(1.05);
}

.reaction-pill.reacted {
  background-color: rgba(153, 27, 27, 0.12);
  border-color: var(--brand-primary);
}

.reaction-emoji {
  font-size: 16px;
}

.reaction-count {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-muted);
}

.reaction-pill.reacted .reaction-count {
  color: var(--brand-primary);
}

/* Floating Actions Bar */
.message-actions-bar {
  position: absolute;
  top: -24px;
  right: 24px;
  background-color: var(--bg-floating);
  backdrop-filter: blur(10px);
  border: 1.5px solid var(--glass-border);
  border-radius: 12px;
  display: flex;
  padding: 5px;
  box-shadow: var(--shadow-xl);
  z-index: 10;
}

.message-action-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: 8px;
  transition: all var(--transition-fast);
}

.message-action-btn:hover {
  background-color: var(--bg-modifier-hover);
  color: var(--brand-primary);
  transform: translateY(-2px);
}

.action-bar-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent !important;
  border: none !important;
  color: var(--text-secondary) !important;
  cursor: pointer;
  border-radius: 8px;
  transition: all var(--transition-fast);
  box-shadow: none !important;
  outline: none !important;
}

.action-bar-btn:hover {
  background-color: var(--bg-modifier-hover) !important;
  color: var(--brand-light) !important;
}

.quick-emoji-picker {
  position: absolute;
  bottom: 120%;
  right: 0;
  background-color: var(--bg-floating);
  backdrop-filter: blur(20px);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  padding: 10px;
  display: flex;
  gap: 6px;
  box-shadow: var(--shadow-xl);
}

.emoji-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent !important;
  border: none !important;
  font-size: 20px;
  cursor: pointer;
  border-radius: 10px;
  transition: all var(--transition-fast);
  box-shadow: none !important;
  outline: none !important;
}

.emoji-btn:hover {
  background-color: var(--bg-modifier-hover) !important;
  transform: scale(1.2) rotate(10deg);
}

/* Typing Indicator */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  margin-top: auto;
  background: linear-gradient(to top, var(--bg-primary), transparent);
}

.typing-dots {
  display: flex;
  gap: 5px;
}

.typing-dots .dot {
  width: 7px;
  height: 7px;
  background-color: var(--brand-primary);
  border-radius: 50%;
  animation: bounce 1s infinite;
}

.typing-text {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-muted);
  opacity: 0.8;
}

/* Image Viewer Overlay */
.image-viewer-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(2, 6, 23, 0.95);
  backdrop-filter: blur(20px);
  z-index: 10000;
  display: flex;
  flex-direction: column;
}

.image-viewer-header {
  height: 80px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);
}

.viewer-author-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.viewer-author-name {
  font-size: 18px;
  font-weight: 800;
  color: white;
}

.viewer-timestamp {
  font-size: 13px;
  color: var(--text-muted);
}

.viewer-close-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.viewer-close-btn:hover {
  background: rgba(153, 27, 27, 0.2);
  border-color: var(--brand-primary);
  transform: scale(1.05);
}

.image-viewer-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  overflow: hidden;
}

.image-viewer-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 16px;
  box-shadow: 0 30px 100px rgba(0,0,0,0.8);
}

/* Context Menu */
.message-context-menu {
  position: fixed;
  background: linear-gradient(145deg, var(--bg-floating), rgba(15, 23, 42, 0.98));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--glass-border);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255,255,255,0.04) inset;
  padding: 6px;
  min-width: 200px;
  z-index: 9999;
}

.message-context-menu button {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  width: 100% !important;
  padding: 10px 14px !important;
  background: transparent !important;
  border: none !important;
  border-radius: 10px !important;
  color: var(--text-secondary) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  text-align: left !important;
  transition: all 0.15s ease !important;
  box-shadow: none !important;
  outline: none !important;
  font-family: inherit !important;
  letter-spacing: -0.01em !important;
}

.message-context-menu button:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: var(--text-primary) !important;
  transform: translateX(2px) !important;
}

.message-context-menu button svg {
  flex-shrink: 0;
  opacity: 0.8;
}

.message-context-menu button:hover svg {
  opacity: 1;
}

.message-context-menu button.danger {
  color: #ef4444 !important;
}

.message-context-menu button.danger:hover {
  background: rgba(239, 68, 68, 0.12) !important;
  color: #f87171 !important;
}

.message-context-menu button.disabled {
  color: var(--text-muted) !important;
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.context-menu-divider {
  height: 1px;
  background: var(--glass-border);
  margin: 6px 0;
  opacity: 0.5;
}

.context-menu-item {
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 700;
}

/* Server Info Embed Styles */
.server-info-embed {
  display: flex;
  background-color: #2b2d31;
  border-radius: 4px;
  margin-top: 8px;
  overflow: hidden;
  max-width: 432px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.embed-accent {
  width: 4px;
  background-color: var(--brand-primary);
}

.embed-content {
  padding: 12px 16px;
  flex: 1;
}

.embed-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
}

.embed-section {
  margin-bottom: 12px;
}

.section-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  margin-bottom: 4px;
  letter-spacing: 0.02em;
}

.section-item {
  display: flex;
  gap: 4px;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.section-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.label {
  color: #b5bac1;
}

.value {
  color: #dbdee1;
}

.owner-value {
  color: #00a8fc;
  cursor: pointer;
}

.owner-value:hover {
  text-decoration: underline;
}

.embed-footer {
  font-size: 0.7rem;
  color: #949ba4;
  margin-top: 4px;
}

@keyframes highlight-reply {
  0% {
    background-color: transparent;
  }
  20% {
    background-color: rgba(185, 28, 28, 0.4);
    box-shadow: 0 0 15px rgba(185, 28, 28, 0.4);
  }
  80% {
    background-color: rgba(185, 28, 28, 0.2);
    box-shadow: 0 0 5px rgba(185, 28, 28, 0.2);
  }
  100% {
    background-color: transparent;
    box-shadow: none;
  }
}

.highlight-animation {
  animation: highlight-reply 2s ease-in-out;
  border-radius: 8px;
}

/* ===== Discord-Style Embed Blocks ===== */

.discord-embed {
  background: var(--bg-secondary);
  border-radius: 12px;
  max-width: 520px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 6px;
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.45;
  border: 1px solid var(--glass-border);
  overflow: hidden;
  word-break: break-word;
  transition: all 0.2s ease;
}

.discord-embed:hover {
  background: var(--bg-floating);
}

.discord-embed-inner {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  max-width: 100%;
  overflow: hidden;
}

.discord-embed-body {
  flex: 1;
  min-width: 0;
  display: flex;
  max-width: 100%;
  flex-direction: column;
  gap: 6px;
}

/* Author row */
.embed-author {
  display: flex;
  align-items: center;
  gap: 8px;
}

.embed-author-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
}

.embed-author-name {
  font-size: 13px;
  font-weight: 600;
  color: #e3e5e8;
}

.embed-author-name.link,
.embed-title.link {
  text-decoration: none;
  color: #00b0f4;
}

.embed-author-name.link:hover,
.embed-title.link:hover {
  text-decoration: underline;
}

/* Title */
.embed-title-row {
  margin-top: 2px;
}

.embed-title {
  font-size: 15px;
  font-weight: 700;
  color: #f2f3f5;
  line-height: 1.3;
}

/* Description */
.embed-description {
  font-size: 13.5px;
  color: #dbdee1;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Fields */
.embed-fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 4px;
}

.embed-field.full {
  grid-column: 1 / -1;
}

.embed-field.inline {
  grid-column: span 1;
}

.embed-field-name {
  font-size: 12px;
  font-weight: 700;
  color: #f2f3f5;
  margin-bottom: 2px;
}

.embed-field-value {
  font-size: 13px;
  color: #dbdee1;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Large image */
.embed-image {
  display: block;
  max-width: 100%;
  max-height: 300px;
  border-radius: 4px;
  margin-top: 6px;
  object-fit: cover;
}

/* Footer row */
.embed-footer-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.embed-footer-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
}

.embed-footer-text {
  font-size: 12px;
  color: #949ba4;
}

.embed-footer-sep {
  font-size: 12px;
  color: #6a6f7a;
}

/* Thumbnail (top-right) */
.discord-embed-thumbnail {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}

.discord-embed-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Video */
.embed-video {
  display: block;
  max-width: 100%;
  border-radius: 4px;
  margin-top: 8px;
}

/* Webhook message subtle indicator */
.webhook-message .message-item {
  border-left: none;
}

/* ===== Discord-Style Markdown Formatting ===== */
.markdown-bold {
  font-weight: 700 !important;
  color: inherit;
}

.markdown-italic {
  font-style: italic !important;
  color: inherit;
}

.markdown-strikethrough {
  text-decoration: line-through !important;
  opacity: 0.85;
}

.markdown-underline {
  text-decoration: underline !important;
}

.markdown-spoiler {
  background-color: #202225;
  color: transparent;
  border-radius: 3px;
  padding: 0 3px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.markdown-spoiler.revealed,
.markdown-spoiler:hover {
  background-color: rgba(255, 255, 255, 0.12);
  color: inherit;
}

.discord-inline-code {
  font-family: Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace;
  font-size: 0.85em;
  background: rgba(30, 31, 34, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  padding: 0.15em 0.4em;
  color: #e3e5e8;
  white-space: pre-wrap;
  word-break: break-word;
}

.discord-code-block-wrapper {
  position: relative;
  margin: 8px 0;
  border-radius: 8px;
  overflow: hidden;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.discord-code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  padding: 5px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.discord-code-lang-tag {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #949ba4;
  background: rgba(255, 255, 255, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
}

.code-copy-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: #dbdee1;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.code-copy-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.2);
}

.discord-code-block {
  font-family: Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace;
  font-size: 0.85em;
  background: transparent;
  padding: 10px 14px;
  margin: 0;
  color: #dbdee1;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
}

.discord-code-block code {
  font-family: inherit;
  background: none;
  padding: 0;
  border: none;
}

/* Syntax Highlighting Styles */
.syntax-line {
  line-height: 1.5;
}

/* Diff */
.syntax-diff-add {
  color: #4ade80 !important;
  background-color: rgba(74, 222, 128, 0.12);
  display: block;
  padding: 1px 4px;
  border-radius: 2px;
}

.syntax-diff-remove {
  color: #f87171 !important;
  background-color: rgba(248, 113, 113, 0.12);
  display: block;
  padding: 1px 4px;
  border-radius: 2px;
}

.syntax-diff-warn {
  color: #fbbf24 !important;
  background-color: rgba(251, 191, 36, 0.12);
  display: block;
  padding: 1px 4px;
  border-radius: 2px;
}

.syntax-diff-header {
  color: #38bdf8 !important;
  font-weight: 700;
}

.syntax-diff-neutral {
  color: #949ba4;
}

/* INI */
.syntax-ini-section {
  color: #38bdf8;
  font-weight: 700;
}

.syntax-ini-key {
  color: #facc15;
  font-weight: 600;
}

.syntax-ini-sep {
  color: #949ba4;
  margin: 0 2px;
}

.syntax-ini-val {
  color: #e2e8f0;
}

/* FIX */
.syntax-fix-badge {
  color: #38bdf8;
  font-weight: 700;
  background: rgba(56, 189, 248, 0.15);
  padding: 1px 4px;
  border-radius: 3px;
  margin-right: 4px;
}

.syntax-fix-ok {
  color: #4ade80;
  font-weight: 700;
}

.syntax-fix-err {
  color: #f87171;
  font-weight: 700;
}

.syntax-fix-warn {
  color: #fbbf24;
  font-weight: 700;
}

.syntax-fix-num {
  color: #c084fc;
  font-weight: 600;
}

/* YAML */
.syntax-yaml-key {
  color: #60a5fa;
  font-weight: 700;
  margin-right: 6px;
}

.syntax-yaml-val {
  color: #34d399;
}

/* ELM badge */
.syntax-elm-badge {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(168, 85, 247, 0.2));
  border: 1px solid rgba(56, 189, 248, 0.3);
  color: #38bdf8;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
  display: inline-block;
}

/* JSON */
.syntax-json-key {
  color: #60a5fa;
  font-weight: 600;
}

.syntax-json-str {
  color: #4ade80;
}

.syntax-json-val {
  color: #f59e0b;
  font-weight: 600;
}

/* Discord Markdown Headings */
.discord-h1 {
  font-size: 1.4em;
  font-weight: 800;
  color: #f2f3f5;
  margin: 6px 0 4px 0;
}

.discord-h2 {
  font-size: 1.2em;
  font-weight: 750;
  color: #f2f3f5;
  margin: 5px 0 3px 0;
}

.discord-h3 {
  font-size: 1.05em;
  font-weight: 700;
  color: #e3e5e8;
  margin: 4px 0 2px 0;
}

/* Discord Blockquote */
.discord-blockquote {
  border-left: 3px solid #4e5058;
  margin: 4px 0;
  padding-left: 10px;
  color: #dbdee1;
  font-style: normal;
}

/* Discord Dynamic Timestamp */
.discord-timestamp {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 0.88em;
  color: #c9cdfb;
  font-weight: 500;
  cursor: default;
  display: inline-block;
}

/* Discord Mention Pills */
.discord-mention {
  background: rgba(88, 101, 242, 0.25);
  color: #c9cdfb;
  font-weight: 600;
  border-radius: 3px;
  padding: 0 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.discord-mention:hover {
  background: #5865f2;
  color: #ffffff;
}

.discord-mention.mention-everyone {
  background: rgba(240, 178, 50, 0.2);
  color: #f0b232;
}

.discord-mention.mention-everyone:hover {
  background: #f0b232;
  color: #000000;
}

.discord-mention.mention-channel {
  background: rgba(79, 84, 92, 0.3);
  color: #dbdee1;
}

.discord-mention.mention-channel:hover {
  background: #4f545c;
  color: #ffffff;
}

.message-edited-tag {
  font-size: 10px;
  color: #949ba4;
  margin-left: 4px;
  cursor: help;
  user-select: none;
}

.clickable-embed-image {
  cursor: pointer !important;
  transition: opacity 0.15s ease, transform 0.15s ease !important;
}

.clickable-embed-image:hover {
  opacity: 0.9 !important;
  transform: scale(1.01) !important;
}

/* Clickable (düzenlendi) Tag */
.clickable-edited-tag {
  cursor: pointer !important;
  text-decoration: underline dotted;
  transition: color 0.15s ease;
}

.clickable-edited-tag:hover {
  color: var(--brand-light, #f87171) !important;
}

/* Soft Deleted Message */
.message-text-deleted {
  opacity: 0.6;
  font-style: italic;
  color: #949ba4 !important;
  background: rgba(255, 255, 255, 0.03) !important;
  border-left: 2px dashed #4e5058;
  padding-left: 8px !important;
}

.deleted-notice {
  font-size: 13px;
  user-select: none;
}

/* Inline Message Edit Box */
.inline-message-edit-wrapper {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
  width: 100%;
}

.inline-edit-input {
  width: 100%;
  background: #2b2d31;
  border: 1px solid #5865f2;
  border-radius: 6px;
  color: #f2f3f5;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
  font-family: inherit;
}

.inline-edit-hint {
  font-size: 11px;
  color: #949ba4;
}

.key-badge {
  color: #5865f2;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

/* Edit History Modal */
.edit-history-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.edit-history-modal {
  background: #1e1f22;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);
  overflow: hidden;
}

.edit-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #2b2d31;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.edit-history-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 15px;
  color: #f2f3f5;
}

.edit-history-close-btn {
  background: none;
  border: none;
  color: #949ba4;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.edit-history-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.edit-history-body {
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.edit-history-section-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #b5bac1;
}

.edit-history-current-box {
  background: rgba(88, 101, 242, 0.1);
  border-left: 3px solid #5865f2;
  padding: 10px 14px;
  border-radius: 4px;
  color: #f2f3f5;
  font-size: 14px;
  word-break: break-word;
}

.edit-history-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 6px;
}

.edit-history-card {
  background: #2b2d31;
  border-radius: 8px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.edit-history-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.history-badge {
  font-size: 11px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.08);
  color: #dbdee1;
  padding: 2px 6px;
  border-radius: 4px;
}

.history-timestamp {
  font-size: 11px;
  color: #949ba4;
}

.edit-history-card-content {
  color: #dbdee1;
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
  background: rgba(0, 0, 0, 0.2);
  padding: 8px 10px;
  border-radius: 6px;
}

.edit-history-empty, .edit-history-loading {
  text-align: center;
  padding: 20px;
  color: #949ba4;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageList/MessageList.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,6CAA6C;EAC7C,YAAY;EACZ,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;EAClB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;EACtD,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;EACd,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;EACA;IACE,mDAAmD;IACnD,sDAAsD;EACxD;EACA;IACE,mDAAmD;IACnD,qDAAqD;EACvD;AACF;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,6CAA6C;EAC7C,kBAAkB;EAClB,qFAAqF;EACrF,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8GAA8G;EAC9G,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;;EAEE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;EACrB,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,qFAAqF;EACrF,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qFAAqF;EACrF,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iDAAiD;EACjD,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,sCAAsC;EACtC,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,+EAA+E;EAC/E,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,kFAAkF;EAClF,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,wCAAwC;IACxC,2CAA2C;EAC7C;EACA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;EACA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;AACF;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yDAAyD;AAC3D;;AAEA;;EAEE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,iOAAiO;EACjO,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,iOAAiO;EACjO,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,qFAAqF;EACrF,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gDAAgD;EAChD,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB","sourcesContent":[".message-list {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-primary);\n  position: relative;\n}\n\n.message-list-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n}\n\n/* Custom Scrollbar for Chat Area */\n.message-list-scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.message-list-scroll::-webkit-scrollbar-track {\n  background: var(--bg-primary);\n}\n\n.message-list-scroll::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.15));\n  border-radius: 4px;\n}\n\n.message-list-scroll:hover::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.3));\n  filter: brightness(1.2);\n}\n\n.message-list-scroll::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n.new-messages-button {\n  position: absolute;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--gradient-brand);\n  color: white;\n  padding: 10px 24px;\n  border-radius: 20px;\n  border: none;\n  font-weight: 700;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  box-shadow: 0 8px 24px rgba(153, 27, 27, 0.4);\n  z-index: 100;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  backdrop-filter: blur(8px);\n}\n\n.new-messages-button:hover {\n  transform: translateX(-50%) translateY(-4px);\n  box-shadow: 0 12px 32px rgba(153, 27, 27, 0.6);\n  filter: brightness(1.1);\n}\n\n.new-messages-button:active {\n  transform: translateX(-50%) translateY(0);\n}\n\n/* Premium Welcome State */\n.channel-start {\n  padding: 80px 24px 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 640px;\n  margin: 0 auto 60px;\n}\n\n.channel-start-icon-box {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  margin-bottom: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.channel-start-icon-inner {\n  width: 84px;\n  height: 84px;\n  background: var(--gradient-brand);\n  border-radius: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  z-index: 2;\n  box-shadow: var(--shadow-xl);\n  transform: rotate(-4deg);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.channel-start-icon-glow {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  background: radial-gradient(circle, rgba(153, 27, 27, 0.4) 0%, transparent 70%);\n  filter: blur(20px);\n  z-index: 1;\n  animation: pulse-glow 3s infinite alternate;\n}\n\n.channel-start-title {\n  font-size: 32px;\n  font-weight: 900;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n  letter-spacing: -0.03em;\n}\n\n.channel-start-description {\n  font-size: 16px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  max-width: 480px;\n  margin-bottom: 32px;\n}\n\n.channel-start-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.channel-action-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 38px;\n  padding: 0 18px;\n  background-color: var(--bg-modifier-hover);\n  border: 1px solid var(--glass-border);\n  border-radius: 12px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  white-space: nowrap;\n}\n\n.channel-action-chip:hover {\n  background-color: var(--bg-modifier-active);\n  border-color: var(--brand-primary);\n  color: var(--text-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(153, 27, 27, 0.2);\n}\n\n.channel-start-divider {\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(to right, transparent, var(--glass-border), transparent);\n  margin-top: 48px;\n}\n\n/* Message Items (Discord flat row layout) */\n.message-item {\n  display: flex;\n  gap: 16px;\n  padding: 4px 16px;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.message-item:hover {\n  background-color: rgba(255, 255, 255, 0.02) !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* DM Mode - Self messages right-aligned */\n.message-item-dm {\n  max-width: 100%;\n}\n\n.message-item-self {\n  flex-direction: row-reverse;\n  align-self: flex-end;\n  max-width: 80%;\n  background: transparent !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  padding: 4px 20px;\n}\n\n.message-item-self:hover {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.message-item-self .message-container {\n  align-items: flex-end;\n}\n\n.message-item-self.highlight-animation {\n  animation: highlight-reply-self 2s ease-in-out !important;\n}\n\n@keyframes highlight-reply-self {\n  0%, 100% {\n    background-color: transparent !important;\n    box-shadow: none !important;\n  }\n  20% {\n    background-color: rgba(185, 28, 28, 0.4) !important;\n    box-shadow: 0 0 15px rgba(185, 28, 28, 0.4) !important;\n  }\n  80% {\n    background-color: rgba(185, 28, 28, 0.2) !important;\n    box-shadow: 0 0 5px rgba(185, 28, 28, 0.2) !important;\n  }\n}\n\n/* DM Self message reply context */\n.message-item-self .message-reply-context {\n  flex-direction: row-reverse;\n  border-radius: var(--radius-lg) 0 0 var(--radius-lg);\n  border-left: 1px solid rgba(153, 27, 27, 0.2);\n  border-right: none;\n  background: linear-gradient(315deg, rgba(153, 27, 27, 0.08), rgba(153, 27, 27, 0.04));\n  margin-left: auto;\n}\n\n.message-item-self .message-reply-accent {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n.message-item-self .message-reply-body {\n  text-align: right;\n}\n\n.message-item-self .message-reply-author {\n  /* Swap arrow direction visually by moving icon to right or using a different one, but let's just align text */\n  text-align: right;\n}\n\n/* DM Bubble Styles - Flat Discord Style (no dark bubbles or shadows) */\n.message-bubble-self,\n.message-bubble-other {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  max-width: 100% !important;\n  word-break: break-word;\n  line-height: 1.5;\n}\n\n.message-bubble-self a,\n.message-bubble-self .message-link-highlight,\n.message-bubble-other a,\n.message-bubble-other .message-link-highlight {\n  color: #00a8fc !important;\n  text-decoration: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.message-bubble-self a:hover,\n.message-bubble-self .message-link-highlight:hover,\n.message-bubble-other a:hover,\n.message-bubble-other .message-link-highlight:hover {\n  text-decoration: underline !important;\n}\n\n/* Read receipt / message status */\n.message-status {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 3px;\n  padding-right: 2px;\n}\n\n.message-status-icon {\n  color: var(--brand-light);\n  opacity: 0.7;\n}\n\n.message-status-icon.read {\n  color: #60a5fa;\n  opacity: 1;\n}\n\n\n.message-avatar {\n  flex-shrink: 0;\n  margin-top: 4px;\n  width: 44px;\n  height: 44px;\n}\n\n.avatar-img {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  object-fit: cover;\n  border: 1.5px solid var(--glass-border);\n  box-shadow: var(--shadow-sm);\n  display: block;\n}\n\n.avatar-inner {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background-color: var(--bg-tertiary);\n  border: 1.5px solid var(--glass-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  color: var(--brand-light);\n  font-size: 18px;\n  box-shadow: var(--shadow-sm);\n  transition: transform var(--transition-normal);\n}\n\n.message-item:hover .avatar-inner {\n  transform: scale(1.05) rotate(2deg);\n  border-color: var(--brand-primary);\n}\n\n.message-container {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.message-header {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n}\n\n.message-author {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.bot-tag {\n  background: var(--brand-primary);\n  color: white;\n  font-size: 9px;\n  font-weight: 900;\n  padding: 1px 4px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  height: 14px;\n}\n\n.message-timestamp {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  opacity: 0.5;\n}\n\n.message-edited {\n  font-size: 11px;\n  color: var(--text-muted);\n  opacity: 0.4;\n  font-style: normal;\n}\n\n.message-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.message-text {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #f8fafc;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  font-weight: 500;\n}\n\n.message-link-highlight {\n  color: #00a8fc !important;\n  text-decoration: none !important;\n  font-weight: 500 !important;\n  padding: 0 !important;\n  background: transparent !important;\n  border-radius: 0 !important;\n  border-bottom: none !important;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.message-link-highlight:hover {\n  color: #00a8fc !important;\n  text-decoration: underline !important;\n  background: transparent !important;\n  border-bottom: none !important;\n}\n\n/* Discord-Style Rich Link Embeds */\n.discord-link-embed {\n  margin-top: 6px;\n  max-width: 520px;\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  border-radius: 4px;\n  padding: 12px 16px;\n  box-shadow: none !important;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.discord-link-embed.direct-media-embed {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  max-width: 520px;\n}\n\n.direct-embed-video {\n  max-width: 100%;\n  max-height: 380px;\n  border-radius: 8px;\n  background: #000;\n  display: block;\n}\n\n.direct-embed-image {\n  max-width: 100%;\n  max-height: 380px;\n  border-radius: 8px;\n  object-fit: contain;\n  cursor: pointer;\n  display: block;\n}\n\n.embed-provider-row {\n  font-size: 11px;\n  font-weight: 700;\n  color: #949ba4;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.embed-author-row {\n  font-size: 13px;\n  font-weight: 700;\n  color: #f2f3f5;\n}\n\n.embed-author-link,\n.embed-author-text {\n  color: #f2f3f5;\n  text-decoration: none;\n}\n.embed-author-link:hover {\n  text-decoration: underline;\n}\n\n.embed-title-row {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.embed-title-link {\n  color: #00a8fc !important;\n  text-decoration: none;\n}\n.embed-title-link:hover {\n  text-decoration: underline;\n}\n\n.embed-description-text {\n  font-size: 13px;\n  color: #dbdee1;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.embed-video-container {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 6px;\n  background: #000;\n}\n\n.youtube-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n/* SoundCloud Embed Box */\n.soundcloud-media-container {\n  margin-top: 8px;\n  width: 100%;\n}\n\n.soundcloud-artwork-box {\n  position: relative;\n  width: 100%;\n  max-width: 480px;\n  height: 280px;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  background: #111214;\n}\n\n.soundcloud-artwork-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s ease;\n}\n\n.soundcloud-artwork-box:hover .soundcloud-artwork-img {\n  transform: scale(1.02);\n}\n\n.soundcloud-play-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.35);\n  transition: background-color 0.2s ease;\n}\n\n.soundcloud-artwork-box:hover .soundcloud-play-overlay {\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.soundcloud-play-button {\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  background: #ff5500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 16px rgba(255, 85, 0, 0.5);\n  transition: transform 0.15s ease;\n}\n\n.soundcloud-artwork-box:hover .soundcloud-play-button {\n  transform: scale(1.1);\n}\n\n.embed-thumbnail-container {\n  margin-top: 8px;\n  max-width: 100%;\n  max-height: 280px;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.embed-thumbnail-img {\n  max-width: 100%;\n  max-height: 280px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.message-reply-context {\n  display: flex;\n  align-items: stretch;\n  background: linear-gradient(135deg, rgba(153, 27, 27, 0.08), rgba(153, 27, 27, 0.04));\n  border: 1px solid rgba(153, 27, 27, 0.2);\n  border-left: none;\n  padding: 8px 12px;\n  border-radius: 0 var(--radius-lg) var(--radius-lg) 0;\n  margin-bottom: 8px;\n  cursor: pointer;\n  max-width: 520px;\n  transition: all var(--transition-fast);\n  overflow: hidden;\n}\n\n.message-reply-accent {\n  width: 3px;\n  min-width: 3px;\n  background: var(--brand-primary);\n  border-radius: 3px;\n  margin-right: 10px;\n  flex-shrink: 0;\n}\n\n.message-reply-context:hover {\n  background: linear-gradient(135deg, rgba(153, 27, 27, 0.14), rgba(153, 27, 27, 0.08));\n  border-color: rgba(153, 27, 27, 0.4);\n}\n\n.message-reply-author {\n  display: block;\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--brand-light);\n  margin-bottom: 4px;\n}\n\n.message-reply-preview {\n  font-size: 13px;\n  color: var(--text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.message-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n.attachment-item {\n  max-width: 100% !important;\n  display: block;\n}\n\n.attachment-image-wrapper {\n  width: 100%;\n  max-width: 400px !important;\n  max-height: 300px !important;\n  aspect-ratio: auto;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--glass-border);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background-color: rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-image-wrapper:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5);\n  border-color: var(--brand-primary);\n}\n\n.attachment-image-wrapper img {\n  display: block;\n  max-width: 400px !important;\n  max-height: 300px !important;\n  width: auto !important;\n  height: auto !important;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.attachment-file-box {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 12px 20px;\n  border-radius: 12px;\n  text-decoration: none;\n  color: inherit;\n  transition: 0.2s;\n  min-width: 280px;\n}\n\n.attachment-file-box:hover {\n  background: rgba(30, 41, 59, 0.8);\n  border-color: var(--brand-primary);\n}\n\n.file-icon-box {\n  font-size: 24px;\n}\n\n.file-name {\n  font-weight: 700;\n  font-size: 14px;\n  color: #f8fafc;\n  margin-bottom: 2px;\n}\n\n.file-meta {\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n\n.message-reactions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.reaction-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid var(--glass-border);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-width: 44px;\n  justify-content: center;\n}\n\n.reaction-pill:hover {\n  border-color: var(--brand-primary);\n  background-color: rgba(153, 27, 27, 0.05);\n  transform: scale(1.05);\n}\n\n.reaction-pill.reacted {\n  background-color: rgba(153, 27, 27, 0.12);\n  border-color: var(--brand-primary);\n}\n\n.reaction-emoji {\n  font-size: 16px;\n}\n\n.reaction-count {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text-muted);\n}\n\n.reaction-pill.reacted .reaction-count {\n  color: var(--brand-primary);\n}\n\n/* Floating Actions Bar */\n.message-actions-bar {\n  position: absolute;\n  top: -24px;\n  right: 24px;\n  background-color: var(--bg-floating);\n  backdrop-filter: blur(10px);\n  border: 1.5px solid var(--glass-border);\n  border-radius: 12px;\n  display: flex;\n  padding: 5px;\n  box-shadow: var(--shadow-xl);\n  z-index: 10;\n}\n\n.message-action-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all var(--transition-fast);\n}\n\n.message-action-btn:hover {\n  background-color: var(--bg-modifier-hover);\n  color: var(--brand-primary);\n  transform: translateY(-2px);\n}\n\n.action-bar-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent !important;\n  border: none !important;\n  color: var(--text-secondary) !important;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all var(--transition-fast);\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.action-bar-btn:hover {\n  background-color: var(--bg-modifier-hover) !important;\n  color: var(--brand-light) !important;\n}\n\n.quick-emoji-picker {\n  position: absolute;\n  bottom: 120%;\n  right: 0;\n  background-color: var(--bg-floating);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  padding: 10px;\n  display: flex;\n  gap: 6px;\n  box-shadow: var(--shadow-xl);\n}\n\n.emoji-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent !important;\n  border: none !important;\n  font-size: 20px;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: all var(--transition-fast);\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.emoji-btn:hover {\n  background-color: var(--bg-modifier-hover) !important;\n  transform: scale(1.2) rotate(10deg);\n}\n\n/* Typing Indicator */\n.typing-indicator {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 24px;\n  margin-top: auto;\n  background: linear-gradient(to top, var(--bg-primary), transparent);\n}\n\n.typing-dots {\n  display: flex;\n  gap: 5px;\n}\n\n.typing-dots .dot {\n  width: 7px;\n  height: 7px;\n  background-color: var(--brand-primary);\n  border-radius: 50%;\n  animation: bounce 1s infinite;\n}\n\n.typing-text {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-muted);\n  opacity: 0.8;\n}\n\n/* Image Viewer Overlay */\n.image-viewer-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(2, 6, 23, 0.95);\n  backdrop-filter: blur(20px);\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n}\n\n.image-viewer-header {\n  height: 80px;\n  padding: 0 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);\n}\n\n.viewer-author-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.viewer-author-name {\n  font-size: 18px;\n  font-weight: 800;\n  color: white;\n}\n\n.viewer-timestamp {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.viewer-close-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.viewer-close-btn:hover {\n  background: rgba(153, 27, 27, 0.2);\n  border-color: var(--brand-primary);\n  transform: scale(1.05);\n}\n\n.image-viewer-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  overflow: hidden;\n}\n\n.image-viewer-content img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 16px;\n  box-shadow: 0 30px 100px rgba(0,0,0,0.8);\n}\n\n/* Context Menu */\n.message-context-menu {\n  position: fixed;\n  background: linear-gradient(145deg, var(--bg-floating), rgba(15, 23, 42, 0.98));\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--glass-border);\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255,255,255,0.04) inset;\n  padding: 6px;\n  min-width: 200px;\n  z-index: 9999;\n}\n\n.message-context-menu button {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  width: 100% !important;\n  padding: 10px 14px !important;\n  background: transparent !important;\n  border: none !important;\n  border-radius: 10px !important;\n  color: var(--text-secondary) !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  text-align: left !important;\n  transition: all 0.15s ease !important;\n  box-shadow: none !important;\n  outline: none !important;\n  font-family: inherit !important;\n  letter-spacing: -0.01em !important;\n}\n\n.message-context-menu button:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: var(--text-primary) !important;\n  transform: translateX(2px) !important;\n}\n\n.message-context-menu button svg {\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n.message-context-menu button:hover svg {\n  opacity: 1;\n}\n\n.message-context-menu button.danger {\n  color: #ef4444 !important;\n}\n\n.message-context-menu button.danger:hover {\n  background: rgba(239, 68, 68, 0.12) !important;\n  color: #f87171 !important;\n}\n\n.message-context-menu button.disabled {\n  color: var(--text-muted) !important;\n  opacity: 0.4 !important;\n  cursor: not-allowed !important;\n  pointer-events: none !important;\n}\n\n.context-menu-divider {\n  height: 1px;\n  background: var(--glass-border);\n  margin: 6px 0;\n  opacity: 0.5;\n}\n\n.context-menu-item {\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n/* Server Info Embed Styles */\n.server-info-embed {\n  display: flex;\n  background-color: #2b2d31;\n  border-radius: 4px;\n  margin-top: 8px;\n  overflow: hidden;\n  max-width: 432px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.embed-accent {\n  width: 4px;\n  background-color: var(--brand-primary);\n}\n\n.embed-content {\n  padding: 12px 16px;\n  flex: 1;\n}\n\n.embed-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 12px;\n}\n\n.embed-section {\n  margin-bottom: 12px;\n}\n\n.section-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  letter-spacing: 0.02em;\n}\n\n.section-item {\n  display: flex;\n  gap: 4px;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.section-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.grid-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  color: #b5bac1;\n}\n\n.value {\n  color: #dbdee1;\n}\n\n.owner-value {\n  color: #00a8fc;\n  cursor: pointer;\n}\n\n.owner-value:hover {\n  text-decoration: underline;\n}\n\n.embed-footer {\n  font-size: 0.7rem;\n  color: #949ba4;\n  margin-top: 4px;\n}\n\n@keyframes highlight-reply {\n  0% {\n    background-color: transparent;\n  }\n  20% {\n    background-color: rgba(185, 28, 28, 0.4);\n    box-shadow: 0 0 15px rgba(185, 28, 28, 0.4);\n  }\n  80% {\n    background-color: rgba(185, 28, 28, 0.2);\n    box-shadow: 0 0 5px rgba(185, 28, 28, 0.2);\n  }\n  100% {\n    background-color: transparent;\n    box-shadow: none;\n  }\n}\n\n.highlight-animation {\n  animation: highlight-reply 2s ease-in-out;\n  border-radius: 8px;\n}\n\n/* ===== Discord-Style Embed Blocks ===== */\n\n.discord-embed {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  max-width: 520px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 6px;\n  padding: 14px 16px;\n  font-size: 14px;\n  line-height: 1.45;\n  border: 1px solid var(--glass-border);\n  overflow: hidden;\n  word-break: break-word;\n  transition: all 0.2s ease;\n}\n\n.discord-embed:hover {\n  background: var(--bg-floating);\n}\n\n.discord-embed-inner {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.discord-embed-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  max-width: 100%;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* Author row */\n.embed-author {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.embed-author-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.embed-author-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #e3e5e8;\n}\n\n.embed-author-name.link,\n.embed-title.link {\n  text-decoration: none;\n  color: #00b0f4;\n}\n\n.embed-author-name.link:hover,\n.embed-title.link:hover {\n  text-decoration: underline;\n}\n\n/* Title */\n.embed-title-row {\n  margin-top: 2px;\n}\n\n.embed-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f2f3f5;\n  line-height: 1.3;\n}\n\n/* Description */\n.embed-description {\n  font-size: 13.5px;\n  color: #dbdee1;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Fields */\n.embed-fields {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.embed-field.full {\n  grid-column: 1 / -1;\n}\n\n.embed-field.inline {\n  grid-column: span 1;\n}\n\n.embed-field-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: #f2f3f5;\n  margin-bottom: 2px;\n}\n\n.embed-field-value {\n  font-size: 13px;\n  color: #dbdee1;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Large image */\n.embed-image {\n  display: block;\n  max-width: 100%;\n  max-height: 300px;\n  border-radius: 4px;\n  margin-top: 6px;\n  object-fit: cover;\n}\n\n/* Footer row */\n.embed-footer-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  flex-wrap: wrap;\n}\n\n.embed-footer-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.embed-footer-text {\n  font-size: 12px;\n  color: #949ba4;\n}\n\n.embed-footer-sep {\n  font-size: 12px;\n  color: #6a6f7a;\n}\n\n/* Thumbnail (top-right) */\n.discord-embed-thumbnail {\n  flex-shrink: 0;\n  width: 80px;\n  height: 80px;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.discord-embed-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Video */\n.embed-video {\n  display: block;\n  max-width: 100%;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n/* Webhook message subtle indicator */\n.webhook-message .message-item {\n  border-left: none;\n}\n\n/* ===== Discord-Style Markdown Formatting ===== */\n.markdown-bold {\n  font-weight: 700 !important;\n  color: inherit;\n}\n\n.markdown-italic {\n  font-style: italic !important;\n  color: inherit;\n}\n\n.markdown-strikethrough {\n  text-decoration: line-through !important;\n  opacity: 0.85;\n}\n\n.markdown-underline {\n  text-decoration: underline !important;\n}\n\n.markdown-spoiler {\n  background-color: #202225;\n  color: transparent;\n  border-radius: 3px;\n  padding: 0 3px;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.markdown-spoiler.revealed,\n.markdown-spoiler:hover {\n  background-color: rgba(255, 255, 255, 0.12);\n  color: inherit;\n}\n\n.discord-inline-code {\n  font-family: Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace;\n  font-size: 0.85em;\n  background: rgba(30, 31, 34, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 4px;\n  padding: 0.15em 0.4em;\n  color: #e3e5e8;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.discord-code-block-wrapper {\n  position: relative;\n  margin: 8px 0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.discord-code-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.35);\n  padding: 5px 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.discord-code-lang-tag {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: #949ba4;\n  background: rgba(255, 255, 255, 0.06);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.code-copy-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  color: #dbdee1;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.code-copy-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.discord-code-block {\n  font-family: Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace;\n  font-size: 0.85em;\n  background: transparent;\n  padding: 10px 14px;\n  margin: 0;\n  color: #dbdee1;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  line-height: 1.5;\n}\n\n.discord-code-block code {\n  font-family: inherit;\n  background: none;\n  padding: 0;\n  border: none;\n}\n\n/* Syntax Highlighting Styles */\n.syntax-line {\n  line-height: 1.5;\n}\n\n/* Diff */\n.syntax-diff-add {\n  color: #4ade80 !important;\n  background-color: rgba(74, 222, 128, 0.12);\n  display: block;\n  padding: 1px 4px;\n  border-radius: 2px;\n}\n\n.syntax-diff-remove {\n  color: #f87171 !important;\n  background-color: rgba(248, 113, 113, 0.12);\n  display: block;\n  padding: 1px 4px;\n  border-radius: 2px;\n}\n\n.syntax-diff-warn {\n  color: #fbbf24 !important;\n  background-color: rgba(251, 191, 36, 0.12);\n  display: block;\n  padding: 1px 4px;\n  border-radius: 2px;\n}\n\n.syntax-diff-header {\n  color: #38bdf8 !important;\n  font-weight: 700;\n}\n\n.syntax-diff-neutral {\n  color: #949ba4;\n}\n\n/* INI */\n.syntax-ini-section {\n  color: #38bdf8;\n  font-weight: 700;\n}\n\n.syntax-ini-key {\n  color: #facc15;\n  font-weight: 600;\n}\n\n.syntax-ini-sep {\n  color: #949ba4;\n  margin: 0 2px;\n}\n\n.syntax-ini-val {\n  color: #e2e8f0;\n}\n\n/* FIX */\n.syntax-fix-badge {\n  color: #38bdf8;\n  font-weight: 700;\n  background: rgba(56, 189, 248, 0.15);\n  padding: 1px 4px;\n  border-radius: 3px;\n  margin-right: 4px;\n}\n\n.syntax-fix-ok {\n  color: #4ade80;\n  font-weight: 700;\n}\n\n.syntax-fix-err {\n  color: #f87171;\n  font-weight: 700;\n}\n\n.syntax-fix-warn {\n  color: #fbbf24;\n  font-weight: 700;\n}\n\n.syntax-fix-num {\n  color: #c084fc;\n  font-weight: 600;\n}\n\n/* YAML */\n.syntax-yaml-key {\n  color: #60a5fa;\n  font-weight: 700;\n  margin-right: 6px;\n}\n\n.syntax-yaml-val {\n  color: #34d399;\n}\n\n/* ELM badge */\n.syntax-elm-badge {\n  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(168, 85, 247, 0.2));\n  border: 1px solid rgba(56, 189, 248, 0.3);\n  color: #38bdf8;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 700;\n  display: inline-block;\n}\n\n/* JSON */\n.syntax-json-key {\n  color: #60a5fa;\n  font-weight: 600;\n}\n\n.syntax-json-str {\n  color: #4ade80;\n}\n\n.syntax-json-val {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n/* Discord Markdown Headings */\n.discord-h1 {\n  font-size: 1.4em;\n  font-weight: 800;\n  color: #f2f3f5;\n  margin: 6px 0 4px 0;\n}\n\n.discord-h2 {\n  font-size: 1.2em;\n  font-weight: 750;\n  color: #f2f3f5;\n  margin: 5px 0 3px 0;\n}\n\n.discord-h3 {\n  font-size: 1.05em;\n  font-weight: 700;\n  color: #e3e5e8;\n  margin: 4px 0 2px 0;\n}\n\n/* Discord Blockquote */\n.discord-blockquote {\n  border-left: 3px solid #4e5058;\n  margin: 4px 0;\n  padding-left: 10px;\n  color: #dbdee1;\n  font-style: normal;\n}\n\n/* Discord Dynamic Timestamp */\n.discord-timestamp {\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 3px;\n  padding: 1px 5px;\n  font-size: 0.88em;\n  color: #c9cdfb;\n  font-weight: 500;\n  cursor: default;\n  display: inline-block;\n}\n\n/* Discord Mention Pills */\n.discord-mention {\n  background: rgba(88, 101, 242, 0.25);\n  color: #c9cdfb;\n  font-weight: 600;\n  border-radius: 3px;\n  padding: 0 4px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.discord-mention:hover {\n  background: #5865f2;\n  color: #ffffff;\n}\n\n.discord-mention.mention-everyone {\n  background: rgba(240, 178, 50, 0.2);\n  color: #f0b232;\n}\n\n.discord-mention.mention-everyone:hover {\n  background: #f0b232;\n  color: #000000;\n}\n\n.discord-mention.mention-channel {\n  background: rgba(79, 84, 92, 0.3);\n  color: #dbdee1;\n}\n\n.discord-mention.mention-channel:hover {\n  background: #4f545c;\n  color: #ffffff;\n}\n\n.message-edited-tag {\n  font-size: 10px;\n  color: #949ba4;\n  margin-left: 4px;\n  cursor: help;\n  user-select: none;\n}\n\n.clickable-embed-image {\n  cursor: pointer !important;\n  transition: opacity 0.15s ease, transform 0.15s ease !important;\n}\n\n.clickable-embed-image:hover {\n  opacity: 0.9 !important;\n  transform: scale(1.01) !important;\n}\n\n/* Clickable (düzenlendi) Tag */\n.clickable-edited-tag {\n  cursor: pointer !important;\n  text-decoration: underline dotted;\n  transition: color 0.15s ease;\n}\n\n.clickable-edited-tag:hover {\n  color: var(--brand-light, #f87171) !important;\n}\n\n/* Soft Deleted Message */\n.message-text-deleted {\n  opacity: 0.6;\n  font-style: italic;\n  color: #949ba4 !important;\n  background: rgba(255, 255, 255, 0.03) !important;\n  border-left: 2px dashed #4e5058;\n  padding-left: 8px !important;\n}\n\n.deleted-notice {\n  font-size: 13px;\n  user-select: none;\n}\n\n/* Inline Message Edit Box */\n.inline-message-edit-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n  width: 100%;\n}\n\n.inline-edit-input {\n  width: 100%;\n  background: #2b2d31;\n  border: 1px solid #5865f2;\n  border-radius: 6px;\n  color: #f2f3f5;\n  padding: 8px 12px;\n  font-size: 14px;\n  outline: none;\n  font-family: inherit;\n}\n\n.inline-edit-hint {\n  font-size: 11px;\n  color: #949ba4;\n}\n\n.key-badge {\n  color: #5865f2;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/* Edit History Modal */\n.edit-history-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.edit-history-modal {\n  background: #1e1f22;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  width: 100%;\n  max-width: 520px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6);\n  overflow: hidden;\n}\n\n.edit-history-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #2b2d31;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.edit-history-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  font-size: 15px;\n  color: #f2f3f5;\n}\n\n.edit-history-close-btn {\n  background: none;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.edit-history-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.edit-history-body {\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.edit-history-section-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #b5bac1;\n}\n\n.edit-history-current-box {\n  background: rgba(88, 101, 242, 0.1);\n  border-left: 3px solid #5865f2;\n  padding: 10px 14px;\n  border-radius: 4px;\n  color: #f2f3f5;\n  font-size: 14px;\n  word-break: break-word;\n}\n\n.edit-history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.edit-history-card {\n  background: #2b2d31;\n  border-radius: 8px;\n  padding: 12px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.edit-history-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.history-badge {\n  font-size: 11px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.08);\n  color: #dbdee1;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.history-timestamp {\n  font-size: 11px;\n  color: #949ba4;\n}\n\n.edit-history-card-content {\n  color: #dbdee1;\n  font-size: 13px;\n  line-height: 1.4;\n  word-break: break-word;\n  background: rgba(0, 0, 0, 0.2);\n  padding: 8px 10px;\n  border-radius: 6px;\n}\n\n.edit-history-empty, .edit-history-loading {\n  text-align: center;\n  padding: 20px;\n  color: #949ba4;\n  font-size: 13px;\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
